export default __webpack_public_path__ + "static/media/MP0033.aed601af.jpg";